export interface DocumentRedactionFlowNode {
    id: number;
    order: number;
    redaction_type: number; // 1=Edit+Upload, 2=Review only
    redaction_type_name: string;
    type: number; // 0=pending, 1=done, 2=rejected, 3=skipped
    type_name: string;
    user_type: number | null;
    functie_name: string | null;
    directie_id: number | null;
    directie_name: string | null;
    compartiment_id: number | null;
    compartiment_name: string | null;
    user_id: number | null;
    user_name: string | null;
    specific_user_id: number | null;
    specific_user_name: string | null;
    action_date: string | null;
    observations: string | null;
    file_uploaded: string | null;
    file_original: string | null;
}

export interface DocumentRedactionFlowData {
    document_generat_id: number;
    document_registratura_id: number;
    template_id: number;
    redaction_step: string; // 'none' | 'pending' | 'in_progress' | 'complete'
    redaction_step_text: string;
    current_order: number | null;
    current_user_type: number | null;
    total_steps: number;
    completed_steps: number;
    pending_steps: number;
    redactions: DocumentRedactionFlowNode[];
    can_process: boolean;
    can_reorder: boolean;
}

export const REDACTION_TYPES: { [key: number]: { icon: string; label: string; class: string } } = {
    1: { icon: 'edit_document', label: 'Editare + Upload', class: 'redaction-type-edit' },
    2: { icon: 'fact_check', label: 'Review/Aprobare', class: 'redaction-type-review' }
};

export const REDACTION_STATUSES: { [key: number]: { label: string; class: string; icon: string } } = {
    0: { label: 'In asteptare', class: 'status-pending', icon: 'schedule' },
    1: { label: 'Finalizat', class: 'status-done', icon: 'check_circle' },
    2: { label: 'Respins', class: 'status-rejected', icon: 'cancel' },
    3: { label: 'Sarit', class: 'status-skipped', icon: 'skip_next' }
};
